import Typography from '@material-ui/core/Typography';
import styled from 'styled-components';

const TotalsRow = styled.div`
  display: flex;
  padding-bottom: ${props => props.theme.spacing()}px;
  padding-top: ${props => props.theme.spacing()}px;
`;

export const TotalsRowDescription = styled(Typography)`
  && {
    flex: 1;
  }
`;

export const TotalsRowValue = styled(Typography)`
  && {
    align-self: flex-end;
  }
`;

export default TotalsRow;
